// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionFunctionOperator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var m = require('mobx');
  var updateArray = require('share/utils/Izenda.ArrayUtils').updateArray;
  var sortArray = require('share/utils/Izenda.ArrayUtils').sortArray;
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');

  function FunctionDetail(detail) {
    this.name = detail.name;
    this.syntax = detail.syntax;
    this.expressionSyntax = detail.expressionSyntax;
  }

  function ExpressionFunctionOperator(data) {
    var colSortDir = {
      name: 'ASC'
    };
    this.backupFunctionOperators = [];

    var props = {
      functionOperators: [],                // array of FunctionOperator
      pageInfo: new PagingModel(colSortDir)
    };

    m.extendObservable(this, props);

    this.fetchData(data);
  }

  ExpressionFunctionOperator.prototype.fetchData = function (data) {
    data = data || {};

    var createFunctionOperator = function (itemData) {
      return new FunctionDetail(itemData);
    }

    updateArray(
      this.functionOperators,
      data.functionOperators, 
      createFunctionOperator);
      
    this.sort(this.functionOperators);
    
    updateArray(
      this.backupFunctionOperators,
      data.functionOperators, 
      createFunctionOperator);
  }
  
  ExpressionFunctionOperator.prototype.sort = function () {
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    var sortedFunctionOperators = [];
    if (!sortOrders) {
      sortedFunctionOperators = this.backupFunctionOperators;
    } else {
      sortedFunctionOperators = sortArray(this.functionOperators, sortOrders);
    }

    updateArray(
      this.functionOperators,
      sortedFunctionOperators,
      function (itemData) {
        return new FunctionDetail(itemData);
      });
  }

  module.exports = ExpressionFunctionOperator;
} ());



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ExpressionFunctionOperator.js